import { render } from "./PreviewMedia.vue?vue&type=template&id=af252daa&scoped=true"
import script from "./PreviewMedia.vue?vue&type=script&lang=js"
export * from "./PreviewMedia.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af252daa"]])

export default __exports__